export const QUESTION_MATRIX_OPEN_ENDED_DECIMALS_DEFAULT = 0;
export const QUESTION_MATRIX_OPEN_ENDED_MIN_VALUE_DEFAULT =
  Number.NEGATIVE_INFINITY;
export const QUESTION_MATRIX_OPEN_ENDED_MAX_VALUE_DEFAULT =
  Number.POSITIVE_INFINITY;
export const QUESTION_MATRIX_OPEN_ENDED_INPUT_REQUIRED_DEFAULT = false;
export const QUESTION_MATRIX_OPEN_ENDED_CONSTANT_SUM_TOTAL_VALUE_DEFAULT =
  Number.POSITIVE_INFINITY;
export const QUESTION_MATRIX_OPEN_ENDED_STYLES = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL',
};

export const QUESTION_MATRIX_OPEN_ENDED_INPUT_SIZES = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
  // this will be used only for vertical style
  FULL_WIDTH: 'FULL_WIDTH',
};

export const QUESTION_MATRIX_OPEN_ENDED_SIGN_PLACEMENTS = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  // this will be used only for text open ended
  NONE: 'NONE',
};

export const QUESTION_MATRIX_OPEN_ENDED_CONSTANT_SUM_TYPES = {
  CONTINUOUS_SUM: 'CONTINUOUS_SUM',
  MUST_TOTAL: 'MUST_TOTAL',
};

export const QUESTION_MATRIX_OPEN_ENDED_SCROLL_ANIMATION_TIME_HORIZONTAL = 400;
export const QUESTION_MATRIX_OPEN_ENDED_SCROLL_ANIMATION_TIME_VERTICAL = 600;
export const QUESTION_MATRIX_OPEN_ENDED_NUMERIC_EXCLUDE_SYMBOLS = ['e', 'E'];
